'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _authService = require('./services/authService');

var _authService2 = _interopRequireDefault(_authService);

var _navbar = require('./navbar/navbar');

var _navbar2 = _interopRequireDefault(_navbar);

var _navbar3 = require('./navbar2/navbar2');

var _navbar4 = _interopRequireDefault(_navbar3);

var _CarsNowAppConfig = require('../../../CarsNowAppConfig');

var _CarsNowAppConfig2 = _interopRequireDefault(_CarsNowAppConfig);

var _authInterceptorService = require('./services/authInterceptorService');

var _authInterceptorService2 = _interopRequireDefault(_authInterceptorService);

var _loadingService = require('./services/loadingService');

var _loadingService2 = _interopRequireDefault(_loadingService);

var _lookupService = require('./services/lookupService');

var _lookupService2 = _interopRequireDefault(_lookupService);

var _pushService = require('./services/pushService');

var _pushService2 = _interopRequireDefault(_pushService);

var _notificationService = require('./services/notificationService');

var _notificationService2 = _interopRequireDefault(_notificationService);

var _addPromiseService = require('./services/addPromiseService');

var _addPromiseService2 = _interopRequireDefault(_addPromiseService);

var _addEditEnquiryExtraService = require('./services/addEditEnquiryExtraService');

var _addEditEnquiryExtraService2 = _interopRequireDefault(_addEditEnquiryExtraService);

var _addEditFinancialProductService = require('./services/addEditFinancialProductService');

var _addEditFinancialProductService2 = _interopRequireDefault(_addEditFinancialProductService);

var _utilsService = require('./services/utilsService');

var _utilsService2 = _interopRequireDefault(_utilsService);

var _print = require('./services/print.service');

var _print2 = _interopRequireDefault(_print);

var _export = require('./services/export.service');

var _export2 = _interopRequireDefault(_export);

var _mail = require('./services/mail.service');

var _mail2 = _interopRequireDefault(_mail);

var _admin = require('./services/admin.service');

var _admin2 = _interopRequireDefault(_admin);

var _file = require('./services/file.service');

var _file2 = _interopRequireDefault(_file);

var _branding = require('./services/branding.service');

var _branding2 = _interopRequireDefault(_branding);

var _performanceManagementService = require('./services/performanceManagementService');

var _performanceManagementService2 = _interopRequireDefault(_performanceManagementService);

var _integration = require('./services/integration.service');

var _integration2 = _interopRequireDefault(_integration);

var _customForms = require('./services/customForms.service');

var _customForms2 = _interopRequireDefault(_customForms);

var _barChart = require('./charting/barChart/barChart');

var _barChart2 = _interopRequireDefault(_barChart);

var _dialogService = require('./services/dialogService');

var _dialogService2 = _interopRequireDefault(_dialogService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_navbar2.default, _navbar4.default, _barChart2.default]).service('authService', _authService2.default).service('authInterceptorService', _authInterceptorService2.default).service('loadingService', _loadingService2.default).service('lookupService', _lookupService2.default).service('pushService', _pushService2.default).service('notificationService', _notificationService2.default).service('addPromiseService', _addPromiseService2.default).service('addEditEnquiryExtraService', _addEditEnquiryExtraService2.default).service('addEditFinancialProductService', _addEditFinancialProductService2.default).service('utilsService', _utilsService2.default).service('printService', _print2.default).service('exportService', _export2.default).service('mailService', _mail2.default).service('adminService', _admin2.default).service('fileService', _file2.default).service('brandingService', _branding2.default).service('performanceManagementService', _performanceManagementService2.default).service('integrationService', _integration2.default).service('customFormsService', _customForms2.default).service('dialogService', _dialogService2.default).config(function ($httpProvider) {
  "ngInject";

  $httpProvider.interceptors.push('authInterceptorService');
}).constant('appConfig', APP_CONFIG).name;

exports.default = commonModule;


// WEBPACK FOOTER //
// ./client/app/common/common.js